/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

// TODO Set the correct article ID here
// const ARTICLE_ID = '00000000'

export function AppComponent() {
  // Similar to componentDidMount and componentDidUpdate:
  React.useEffect(() => {
    // Update the document title using the browser API
    const script = document.createElement('script')

    script.src = 'https://dpa-infocom.s3-eu-west-1.amazonaws.com/js/dpa.js'
    script.async = true

    document.body.appendChild(script)
  })

  const params = new URL(window.location).searchParams
  const type = params.get('type')

  if (type === 'direktwahlfrage') {
    return (
      <div className='index'>
        <ThemeSwitch />
        <div className='ta text'>
          <h4 className='graphicTitle'>Die Kanzlerfrage</h4>
          {/* <div className='graphicSub'>
              <div>Durchmesser in Zentimeter</div>
            </div> */}

          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='ranking'
            data-max-parties='all'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/dpa-live-wahlen/bundestagswahl/direktwahlfrage/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }

  if (type === 'umfrageverlauf') {
    return (
      <div className='index'>
        <ThemeSwitch />
        <div className='ta text'>
          <h4 className='graphicTitle'>Die Sonntagsfrage</h4>
          {/* <div className='graphicSub'>
              <div>Durchmesser in Zentimeter</div>
            </div> */}
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='chart'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/dpa-live-wahlen/bundestagswahl/umfrageverlauf/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }

  if (type === 'stimmenanteileQuer') {
    return (
      <div className='index'>
        <ThemeSwitch />
        <div className='ta text'>
          <h4 className='graphicTitle'>Stimmenanteile</h4>
          {/* <div className='graphicSub'>
              <div>Durchmesser in Zentimeter</div>
            </div> */}
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='barsList'
            data-max-parties='all'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/dpa-live-wahlen/bundestagswahl/stimmenanteileQuer/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }

  if (type === 'sitzverteilung') {
    return (
      <div className='index'>
        <ThemeSwitch />
        <div className='ta text'>
          <h4 className='graphicTitle'>Sitzverteilung</h4>
          {/* <div className='graphicSub'>
              <div>Durchmesser in Zentimeter</div>
            </div> */}
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='seats'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/dpa-live-wahlen/bundestagswahl/sitzverteilung/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }

  if (type === 'koalitionsrechner') {
    return (
      <div className='index'>
        <ThemeSwitch />
        <div className='ta text'>
          <h4 className='graphicTitle'>Koalitionsrechner</h4>
          {/* <div className='graphicSub'>
              <div>Durchmesser in Zentimeter</div>
            </div> */}
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='coalition'
            data-hide-coalitions='true'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/dpa-live-wahlen/bundestagswahl/koalitionsrechner/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }

  if (type === 'wahlkreisergebnisse') {
    return (
      <div className='index'>
        <ThemeSwitch />
        <div className='ta text'>
          <h4 className='graphicTitle'>Wahlkreisergebnisse</h4>
          {/* <div className='graphicSub'>
              <div>Durchmesser in Zentimeter</div>
            </div> */}
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='votingAreas'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/dpa-live-wahlen/bundestagswahl/wahlkreisergebnisse/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }

  if (type === 'waehlerwanderung') {
    return (
      <div className='index'>
        <ThemeSwitch />
        <div className='ta text'>
          <h4 className='graphicTitle'>Wählerwanderung</h4>
          {/* <div className='graphicSub'>
              <div>Durchmesser in Zentimeter</div>
            </div> */}
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='voterMigration'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/dpa-live-wahlen/bundestagswahl/waehlerwanderung/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }

  if (type === 'mehrheiten-in-den-wahlkreisen') {
    return (
      <div className='index'>
        <ThemeSwitch />
        <div className='ta text'>
          <h4 className='graphicTitle'>Mehrheiten in den Wahlkreisen</h4>
          {/* <div className='graphicSub'>
              <div>Durchmesser in Zentimeter</div>
            </div> */}
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='areaTotal'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/dpa-live-wahlen/bundestagswahl/mehrheiten-in-den-wahlkreisen/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }

  if (type === 'parteihochburgen') {
    return (
      <div className='index'>
        <ThemeSwitch />
        <div className='ta text'>
          <h4 className='graphicTitle'>Parteihochburgen</h4>
          {/* <div className='graphicSub'>
              <div>Durchmesser in Zentimeter</div>
            </div> */}
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='partyStrength'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/dpa-live-wahlen/bundestagswahl/parteihochburgen/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }



  return null
}
